import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import UsersListLayer from "../../components/User/UserListLayer";

const FAQList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="User Management"  />

        <UsersListLayer roles="user"/>
      </MasterLayout>
    </>
  );
};

export default FAQList;
